// extracted by css-extract-rspack-plugin
export default {"menuItem":"oHB5i","menuItemStack":"BAKcp"};